// Captura el evento beforeinstallprompt UNA sola vez por carga de página, en un lugar
// compartido (no atado a un componente) — así, aunque la persona descarte el aviso,
// sigue pudiendo instalar después (el evento queda disponible hasta que se use o
// se recargue la página).
let deferredEvent = null;
let instalado = false;
const listeners = new Set();

function notificar() {
  listeners.forEach((fn) => fn());
}

window.addEventListener('beforeinstallprompt', (e) => {
  e.preventDefault();
  deferredEvent = e;
  notificar();
});

window.addEventListener('appinstalled', () => {
  instalado = true;
  deferredEvent = null;
  notificar();
});

export function estadoInstalacion() {
  return { disponible: !!deferredEvent, instalado };
}

// A diferencia de `instalado` (arriba) — que solo es true tras el evento appinstalled DE ESTA
// sesión de navegación — esto detecta si la app está corriendo instalada en CUALQUIER momento,
// incluyendo aperturas posteriores a la instalación. Es la única señal que existe en iOS/Safari,
// que no dispara beforeinstallprompt ni appinstalled.
export function estaCorriendoInstalada() {
  const enModoStandalone = typeof window.matchMedia === 'function' && window.matchMedia('(display-mode: standalone)').matches;
  const enIOSHomeScreen = window.navigator?.standalone === true;
  return enModoStandalone || enIOSHomeScreen;
}

export function suscribirseInstalacion(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export async function instalarApp() {
  if (!deferredEvent) return null;
  deferredEvent.prompt();
  const { outcome } = await deferredEvent.userChoice;
  // Un evento de beforeinstallprompt solo se puede usar una vez (lo acepten o no) —
  // tras responder, se descarta; si vuelve a ser instalable, el navegador disparará
  // un evento nuevo en la siguiente carga de página.
  deferredEvent = null;
  notificar();
  return outcome;
}
